// @styleguide
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import padStart from 'lodash/padStart';
import { Row, Col } from 'react-bootstrap';
import LoadMore from '../../LoadMore';
import StudentPerformanceSquare from '../../StudentPerformanceSquare';
import * as helpers from '../../reportHelpers';
// import Scale from '../../Scale';

import CardsLegend from '../../CardsLegend';

import './StudentPerformancePerGrade.scss';

const StudentPerformancePerGrade = (props) => {
  const [limit, setLimit] = useState(props.limit);

  function handleOnClick(idQuestion, percentHits) {
    props.handleModal(idQuestion, percentHits);
  }
  return (
    <div className="card">
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col">
            <div className="card-title">
              <i className="pe-7s-graph1 mr-2" />
              {props.title}
            </div>
          </div>
          <div className="col-auto">
            {/* <Scale /> */}
            <CardsLegend />
          </div>
        </div>
        <hr className="my-3" />
        <div className="scale-grade-item--container scale scale-large text-center mb-4">
          {props.items.slice(0, limit).map((item) => (
            <button
              type="button"
              onClick={() => handleOnClick(item.idQuestion, item.percentHits)}
              style={props.studentReport ? { cursor: 'pointer' } : { cursor: 'normal' }}
              className="scale-grade-item"
              disabled={!props.studentReport}
            >
              <div
                className={`scale-step step-${
                  (item.alternativeAnswered === '-' && 'none') ||
                  (item.alternativeAnswered === '' && 'notAnswered') ||
                  (item.canceled && 'canceled') ||
                  item.percentHits
                }`}
              >
                <div className="content">
                  <div>
                    <div>Q{padStart(item.position, 2, '0')}</div>
                    <div className="percentage">
                      {item.alternativeAnswered === '-' ? '-' : `${item.percentHits}%`}
                    </div>
                    <div>
                      {props.answer}: <strong>{item.alternativeAnswered}</strong>
                    </div>
                    <div>
                      {props.correct}: <strong>{item.correctAlternative}</strong>
                    </div>
                    <div style={{ width: '160px' }}>{item.curricularComponent}</div>
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
        {props.items && props.items.length > 10 ? (
          <LoadMore onClick={() => setLimit(limit + props.limit)} />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
StudentPerformancePerGrade.propTypes = {};

StudentPerformancePerGrade.defaultProps = {
  limit: 20,
};

export default StudentPerformancePerGrade;
